// Kept in both frontends because they are deployed as independent applications.
const thousandsFormat = new Intl.NumberFormat("es-AR", { maximumFractionDigits: 1 });
const millionsFormat = new Intl.NumberFormat("es-AR", { maximumFractionDigits: 2 });
const numberFormat = new Intl.NumberFormat("es-AR", { maximumFractionDigits: 0 });

export const currencyLabel = (currency) => {
  const code = String(currency || "").trim().toUpperCase();
  if (["USD", "US$", "U$S"].includes(code)) return "US$";
  if (["ARS", "$", "AR$"].includes(code)) return "AR$";
  return code.replace(/[^A-Z]/g, "").slice(0, 5);
};

export const formatCompactPrice = (value, currency) => {
  const price = Number(value);
  if (!Number.isFinite(price) || price <= 0) return "Consultar";
  // Promote rounded thousands so 999,950 becomes 1M, never 1,000K.
  const millions = price >= 999950;
  const divisor = millions ? 1000000 : price >= 1000 ? 1000 : 1;
  const amount = (millions ? millionsFormat : divisor > 1 ? thousandsFormat : numberFormat).format(price / divisor);
  return `${currencyLabel(currency)} ${amount}${millions ? "M" : divisor > 1 ? "K" : ""}`.trim();
};

export const formatPropertyPrice = (value, currency) => {
  const price = Number(value);
  return Number.isFinite(price) && price > 0
    ? `${currencyLabel(currency)} ${numberFormat.format(price)}`.trim()
    : "Consultar precio";
};

export const pricePerSquareMeter = (price, coveredArea) => {
  const value = Number(price);
  const area = Number(coveredArea);
  return Number.isFinite(value) && value > 0 && Number.isFinite(area) && area > 0
    ? value / area : null;
};

export const formatPublisherName = (value) => {
  const name = String(value || "").trim();
  if (!name) return "";
  const lower = name.toLocaleLowerCase("es-AR");
  return lower.charAt(0).toLocaleUpperCase("es-AR") + lower.slice(1);
};

